import { createRouter, createWebHistory } from 'vue-router'
import MainView from '@/views/MainView.vue'
import ErrorView from '@/views/ErrorView.vue'
import MainPage from '@/pages/MainPage.vue'
import { encryptStorage } from '@/store'
import ApologyPage from '@/pages/ApologyPage.vue'

const routes = [
  {
    path: '/',
    component: MainView,
    meta: { alreadyAuth: true },
    children: [
      {
        path: '/',
        alias: '/',
        component: MainPage
      },
      {
        path: '/apology',
        name: 'Apology',
        component: ApologyPage
      },
    ]
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'ErrorView',
    component: ErrorView,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const ageConfirmed = encryptStorage.getItem("ageConfirmed") === "true";
  const responsibilityConfirmed = encryptStorage.getItem("responsibilityConfirmed") === "true";

  if (!ageConfirmed || !responsibilityConfirmed) {
    if (to.path !== "/apology" && to.path !== "/") {
      return next("/apology");
    }
  }

  next();
});


export default router
